import { render } from "./HandOver.vue?vue&type=template&id=72226eae"
import script from "./HandOver.vue?vue&type=script&lang=js"
export * from "./HandOver.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\shareTeam\\Desktop\\work\\parking\\duty-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__